// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Play Button CSS Module
 * PERFORMANCE OPTIMIZED: Eliminates styled-components runtime overhead
 */
.dCEkHwBW7Tj_UBChiilT {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  opacity: 1;
  color: #fff;
  z-index: 1;
}
/* Hover background moved to .gameCard:hover::before in Game.module.css */
.quN1t0vlPX9NQMJM_e3l {
  width: 160px;
  max-width: 80%;
  height: 36px;
  border-radius: 3px;
  background: var(--play-button-background, linear-gradient(to right, #00df1e, #19b14e));
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  color: white;
}
.Pfw4I2sArpHVFNhS7Azh {
  pointer-events: none;
  cursor: wait;
  background: linear-gradient(110deg, transparent 0%, transparent 35%, rgba(255, 255, 255, 0.18) 50%, transparent 65%, transparent 100%), #15ba48;
  background-size: 250% 100%,
    100% 100%;
  background-repeat: no-repeat;
  animation: QBZlCArn6JlVd2HEpcQp 1.2s ease-in-out infinite;
  opacity: 0.85;
}
@keyframes QBZlCArn6JlVd2HEpcQp {
  0% {
    background-position: 150% 0%,
      0 0;
  }
  100% {
    background-position: -150% 0%, 0 0;
  }
}
.CE6OLxWQVJtbHYJVMRC2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  line-height: 1;
}
.OSsYKUFfTG3K0j4E8l51 {
  display: inline-block;
  opacity: 0.3;
  animation: FDmT_a501EECrH0JqexH 1.2s linear infinite;
}
.OSsYKUFfTG3K0j4E8l51:nth-child(1) {
  animation-delay: 0ms;
}
.OSsYKUFfTG3K0j4E8l51:nth-child(2) {
  animation-delay: 200ms;
}
.OSsYKUFfTG3K0j4E8l51:nth-child(3) {
  animation-delay: 400ms;
}
@keyframes FDmT_a501EECrH0JqexH {
  0% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.3;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/ButtonPlay/ButtonPlay.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;AACA,yEAAyE;AACzE;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sFAAsF;EACtF,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,+IAA+I;EAC/I;aACW;EACX,4BAA4B;EAC5B,yDAAmD;EACnD,aAAa;AACf;AACA;EACE;IACE;SACK;EACP;EACA;IACE,kCAAkC;EACpC;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,oDAAkD;AACpD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/**\n * Play Button CSS Module\n * PERFORMANCE OPTIMIZED: Eliminates styled-components runtime overhead\n */\n.playButtonWrapper {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  opacity: 1;\n  color: #fff;\n  z-index: 1;\n}\n/* Hover background moved to .gameCard:hover::before in Game.module.css */\n.playButton {\n  width: 160px;\n  max-width: 80%;\n  height: 36px;\n  border-radius: 3px;\n  background: var(--play-button-background, linear-gradient(to right, #00df1e, #19b14e));\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 500;\n  color: white;\n}\n.loading {\n  pointer-events: none;\n  cursor: wait;\n  background: linear-gradient(110deg, transparent 0%, transparent 35%, rgba(255, 255, 255, 0.18) 50%, transparent 65%, transparent 100%), #15ba48;\n  background-size: 250% 100%,\n    100% 100%;\n  background-repeat: no-repeat;\n  animation: playButtonFlow 1.2s ease-in-out infinite;\n  opacity: 0.85;\n}\n@keyframes playButtonFlow {\n  0% {\n    background-position: 150% 0%,\n      0 0;\n  }\n  100% {\n    background-position: -150% 0%, 0 0;\n  }\n}\n.dots {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  line-height: 1;\n}\n.dot {\n  display: inline-block;\n  opacity: 0.3;\n  animation: playButtonDotPulse 1.2s linear infinite;\n}\n.dot:nth-child(1) {\n  animation-delay: 0ms;\n}\n.dot:nth-child(2) {\n  animation-delay: 200ms;\n}\n.dot:nth-child(3) {\n  animation-delay: 400ms;\n}\n@keyframes playButtonDotPulse {\n  0% {\n    opacity: 0.3;\n  }\n  40% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0.3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playButtonWrapper": `dCEkHwBW7Tj_UBChiilT`,
	"playButton": `quN1t0vlPX9NQMJM_e3l`,
	"loading": `Pfw4I2sArpHVFNhS7Azh`,
	"playButtonFlow": `QBZlCArn6JlVd2HEpcQp`,
	"dots": `CE6OLxWQVJtbHYJVMRC2`,
	"dot": `OSsYKUFfTG3K0j4E8l51`,
	"playButtonDotPulse": `FDmT_a501EECrH0JqexH`
};
export default ___CSS_LOADER_EXPORT___;
